import CookiesService from './cookies.service';
import SettingsService from './settings.service';
import AlertsService from './alerts.service';
import CloudUserService from './CloudUser.service';
import HelpersService from './helpers.service';
import LanguageService from './language.service';
import UiHelper from './ui.helper.service';
import UserCodeService from './userCode.service';
import CountdownService from './countdown.service';
import EventHelperService from './event.helper.service';
import UtilsService  from './utils.service';

export default angular.module( 'app.app.services.module', [])

	.service('CookiesService', CookiesService)
	.service('AlertsService', AlertsService)
	.service('CloudUserService', CloudUserService)
	.service('AppSettingsService', SettingsService)
	.service('HelpersService', HelpersService)
	.service('LanguageService', LanguageService)
	.service('UiHelper', UiHelper)
	.service('UserCodeService', UserCodeService)
	.service('CountdownService', CountdownService)
	.service('EventHelperService', EventHelperService)
	.service('UtilsService', UtilsService)
	.name;


/** WEBPACK FOOTER **
 ** ./src/services/app/index.js
 **/